import React from "react";
import fields from "../../json/GuestFeilds.json";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import FormSelect from "Common/Custom/FormSelect";
import FormPhoneInput from "Common/Custom/FormPhoneInput";



const EditGuestForm = ({ values, errors, handleChange, handleSubmit, loading, title = "Update Guest",fields }) => {
  const formdata = fields.filter((field) => field.name !== "contry_code");
  return (
    <PageBody
      headerchildren={<HeadingOne>{title}</HeadingOne>}
      onSubmit={handleSubmit}
    >
      {formdata.map((field) => {

        if (field.type === "select") {
          const options = field.options.map((opt) => ({
            value: opt.value,
            label: opt.label
          }));
          return (
            <FormSelect
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              options={options}
              error={errors[field.name]}
            />
          );
        }

        if (field.type === "switch") {
          return (
            <Switch
              key={field.name}
              values={values[field.name]}
              handleChange={handleChange}
              field={field}
              ValueOne="1"
              ValueTwo="0"
              LabelOne="Active"
              LabelTwo="Inactive"
            />
          );
        }
        if(field.type === "tel"){
          return(
            <FormPhoneInput
              key={field.name}
              field={field}
              value={values[field.name]}
              country_code={values['contry_code']}
              handleChange={handleChange}
              error={errors[field.name]}
            />
          )
        }

        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      <FormSubmitButton
        label={`Update`}
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default EditGuestForm;
